import { useState, useEffect} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextInput } from '../../components/input'
import GoBack from '../../components/back/GoBack'
import SettingsMenu from '../staticscreens/SettingsMenu'
import { GetDistributorSubscriptionService, CreateDistributorSubscriptionService, UpdateDistributorSubscriptionService } from '../../services/admin/DistributorSubscriptionServices'

function DistributorSubscriptionPoint() {
 
  const [data,setdata] = useState({points:'',});  
  const [error,seterror] = useState({points:'',}); 


  
   useEffect(()=>{
      getdata()
    },[])
  
    async function getdata() {
      const response = await GetDistributorSubscriptionService()
      if(response?.data?.datas?.length > 0){
          setdata(response?.data?.datas[0])
      }
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }
  

  async function resetform(){
    setdata({points:'',})
    seterror({points:'',})
  }

  async function submitdata() {
     if(!data.points){
        seterror({...error,points:'Points field is required to make changes*'})
    }else{
    if(data?._id === undefined || data?._id === null){
        const response = await CreateDistributorSubscriptionService(data)
        if (response.status === 201) {
          resetform()
          getdata()
          toast.success('Subscription Points Created Successfully')
        } 
    }else{
       const response = await UpdateDistributorSubscriptionService(data,data?._id)
        if (response.status === 200) {
          resetform()
          getdata()
          toast.success('Subscription Points Update Successfully')
        } 
    }
    }
  }

  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }


  

  

  return (
    <div className='md:flex '>


    <SettingsMenu />
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      
      

        <h6 className='font-bold'>Distributor Subscription Points</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create / update <b>Distributor Subscription Points</b>.</h6>
     

        <TextInput 
            mandatory={true}
            label={'Subscription Points'}  
            variant="standard"
            name="points"
            type="number"
            error={error.points}
            value={data.points}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          
          <div className='my-5'>
           <ButtonFilledAutoWidth btnName="Save"  onClick={submitdata} />  
          </div>



    </div>
    </div>
  )
}

export default DistributorSubscriptionPoint